import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import Button from '../../../../../1stlog-ui/src/components/Button'
import {
  useField,
  useFieldContext,
} from '../../../../../1stlog-ui/src/components/Field'
import { useForm } from '../../../../../1stlog-ui/src/components/Form'
import { toast } from '../../../../../1stlog-ui/src/utils'
import { relevantAddressProps } from '../../../OrderEntry/utils'
import { useAddressBook } from '..'

const Wrapper = styled.div`
  display: flex;
`

const AddressBookControls = (props) => {
  const { onApply = lodash.noop } = props

  const { create, update } = useAddressBook()

  const id = useField('id')

  const { prefix } = useFieldContext()

  const form = useForm()

  const getValues = () => lodash.get(form.getState(), `values.${prefix}`)

  // touch all relevant fields and make sure its valid
  const touch = () => {
    form.batch(() => {
      lodash.forEach(relevantAddressProps, (prop) => {
        form.blur(`${prefix}.${prop}`)
      })
    })
    const state = form.getState()
    const errors = lodash.get(state, `errors.${prefix}`)
    if (!lodash.isEmpty(errors)) {
      toast.warning(
        i18n.t('please_fill_required_fields_before_saving_the_address', 'Bitte füllen Sie alle Pflichtfelder aus, bevor Sie eine Adresse speichern.'),
      )
      return false
    }
    return true
  }

  const onCreate = async () => {
    const values = lodash.pick(getValues(), relevantAddressProps)
    if (touch()) {
      const result = await create(values)
      if (result) {
        onApply(result)
      }
    }
  }

  const onUpdate = async () => {
    const values = getValues()
    if (touch()) {
      const result = await update(values)
      if (result) {
        onApply(result)
      }
    }
  }

  return (
    <Wrapper>
      {id ? (
        <div>
          <Button
            sm
            icon="fas fa-save"
            tooltip={i18n.t("update_existing_entry_in_addressbook", "Den bestehenden Eintrag im Adressbuch aktualisieren")}
            onClick={onUpdate}
          >
            {i18n.t('save_changes_to_addressbook', 'Änderungen speichern')}
          </Button>
        </div>
      ) : (
        <div>
          <Button
            sm
            icon="fas fa-save"
            tooltip={i18n.t("save_in_addressbook", "Im Adressbuch speichern")}
            onClick={onCreate}
          >
            {i18n.t("save_in_addressbook", "Im Adressbuch speichern")}
          </Button>
        </div>
      )}
      {id && (
        <div className="ml-2">
          <Button
            sm
            icon="fas fa-save"
            tooltip={i18n.t("save_as_new_entry_in_addressbook", "Im Adressbuch als neuen Eintrag speichern")}
            onClick={onCreate}
          >
            {i18n.t('save_new', 'Neu speichern')}
          </Button>
        </div>
      )}
    </Wrapper>
  )
}

export default AddressBookControls
